import * as THREE from '/src/assets/scripts/libs/three-r97/three.module';

var letterTexture = function(text, styles, size, filter) {
	var texture;
	var canvas, ctx;
	var w = size.w || 2048;
	var h = size.h || 512;
	var tw, th;
	var startWord = 0;
	var curWord = 0;
	var totalWords;
	var scale = [1, 1];
	var globalScale = styles.scale || 1;

	var font = {
		size: styles.size,
		weight: styles.fontWeight,
		family: styles.fontFamily,
		align: styles.align || 'center',
		spacing: styles.letterSpacing * styles.size,
		color: styles.color || 'ffffff',
		blur: styles.blur,
		lineHeight: (styles.lineHeight || 1.2) * styles.size,
		textTransform: styles.textTransform || 'none',
		verticalAlign: styles.verticalAlign || 'top'
	}

	// console.log(text, font.color);
	// console.dir(font);

	var words;
	var line = '';
	var lines = [];
	var lineSize = 0;
	var y = 0;
	var x = 0;
	var yShift = 0;

	function getClosestPowerTwo(num) {
		var res = 1;
		while (res < num) {
			res *= 2;
		}
		return res;
	}

	function measureWord(word) {
		var txt = word.split('');
		var ln = txt.length;
		var w = 0;

		txt.forEach(function(lt, i) {
			w += ctx.measureText(lt).width;
		});

		return {
			w: w + font.spacing * (ln - 1),
			h: font.lineHeight
		}
	}

	function drawWithLetterSpacing(text, y) {
		var txt = text.split('');
		var txtStart;

		if (font.align === 'left' || font.align === 'start') {
			ctx.textAlign = 'left';
			txtStart = -0.5;
		}
		else if (font.align === 'right') {
			txtStart = w - font.spacing;
		}
		else {
			txtStart = (w - ctx.measureText(text).width - (text.length) * font.spacing) / 2;
			ctx.textAlign = 'left';
		}

		txt.forEach(function(lt, i) {
			ctx.fillText(lt, txtStart, y + font.lineHeight * 0.8 - 0.5);
			txtStart = txtStart + font.spacing + ctx.measureText(lt).width;
		});
	}

	function replaceAll(str, find, replace) {
		var re = new RegExp(find, 'g');
		return str.replace(re, replace);
	}

	text = replaceAll(text, '&nbsp;', '\u00a0');
	text = replaceAll(text, '&ndash;', '\u2013');
	text = replaceAll(text, '&mdash;', '\u2014');
	text = replaceAll(text, '&amp;', '\u0026');
	text = replaceAll(text, '&lsquo;', '\u2018');
	text = replaceAll(text, '&rsquo;', '\u2019');
	text = replaceAll(text, '&laquo;', '\u00ab');
	text = replaceAll(text, '&raquo;', '\u00bb');

	if (filter === 'linear') {
		tw = w;
		th = h;
	} else {
		tw = getClosestPowerTwo(w * globalScale);
		th = getClosestPowerTwo(h * globalScale);
	}

	canvas = document.createElement('canvas');

	// canvas.style.position = 'absolute';
	// canvas.style.zIndex = 1000000;
	// canvas.style.left = size.l + 'px';
	// canvas.style.top = size.t + 'px';
	// canvas.style.width = size.w + 'px';
	// canvas.style.height = size.h + 'px';
	// var pw = document.getElementsByClassName('page-wrapper')[0];
	// pw.appendChild(canvas);

	scale[0] = tw / w;
	scale[1] = th / h;

	if (font.blur) {
		scale[0] *= 0.25;
		scale[1] *= 0.25;
	}

	canvas.width = Math.ceil(w * scale[0]);
	canvas.height = Math.ceil(h * scale[1]);

	ctx = canvas.getContext('2d');
	ctx.scale(scale[0], scale[1]);

	if (font.blur) {
		ctx.shadowColor = font.color;
		ctx.shadowBlur = 8;
	} else {
		ctx.shadowBlur = 0;
	}

	// ctx.shadowBlur = 100;
	// ctx.shadowColor = font.color;

	ctx.font = font.weight + ' ' + font.size + 'px ' + font.family;
	ctx.fillStyle = font.color;
	ctx.textAlign = font.align;

	if (font.textTransform === 'uppercase') {
		text = text.toUpperCase();
	}

	y = 0;
	words = text.split(' ');
	totalWords = words.length;

	while (curWord < totalWords) {
		line = words[startWord];
		lineSize = measureWord(line);
		startWord++;
		curWord = startWord;

		x = Math.max(lineSize.w, x);

		while (lineSize.w < w) {
			if (!words[curWord]) break;

			x = Math.max(lineSize.w, x);

			lineSize = measureWord(line + ' ' + words[curWord]);
			if (lineSize.w < w) {
				line += ' ' + words[curWord];
				curWord++;
			}
		}

		startWord = curWord;

		lines.push({
			text: line,
			y: y
		});

		y += lineSize.h;
	}

	if (font.verticalAlign === 'middle') {
		yShift = (h - y) / 2;
	}

	lines.forEach(function(line) {
		drawWithLetterSpacing(line.text, line.y + yShift);
	});

	texture = new THREE.Texture(canvas);

	texture.repeat.set(1, 1);
	texture.offset.set(0, 0);

	if (filter === 'linear') {
		texture.magFilter = THREE.LinearFilter;
		texture.minFilter = THREE.LinearFilter;
	} else {
		texture.wrapS = THREE.RepeatWrapping;
		texture.wrapT = THREE.RepeatWrapping;
	}

	texture.needsUpdate = true;
	texture._size = [w, h];
	texture._textWidth = x;

	return texture;
}

export default letterTexture;